import React, { useState } from "react";
import PageCover from "../Components/Shared/PageCover";
import flightStatus from "../Components/Assets/Images/flightStatus2.jpg";
import { motion } from "framer-motion";
import { Box } from "@mui/material";
import { Container, Row, Col } from "react-bootstrap";
import {
  Tabs,
  Tab,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
} from "@mui/material";
// import { useNavigate } from "react-router-dom";

const FlightStatus = () => {
  const [flightNumber, setFlightNumber] = useState("");
  const [status, setStatus] = useState(null);
  const [value, setValue] = React.useState(0);

  const tabChange = (event, newValue) => {
    setValue(newValue);
  };
  const [flightDate, setFlightDate] = React.useState("");

  const changeDropdown = (event) => {
    setFlightDate(event.target.value);
  };
  const handleInputChange = (e) => {
    setFlightNumber(e.target.value);
  };

  const checkFlightStatus = () => {
    const mockStatus = flightNumber === "123" ? "you will get this, when its time" : "Underworking...";
    setStatus(mockStatus);
  };
//  const navigate = useNavigate();
  return (
    <>
      <motion.div
        initial={{ x: 120, opacity: 0 }}
        whileInView={{ x: 0, opacity: 1 }}
        transition={{ duration: 1, ease: "easeInOut" }}
        viewport={{ once: true }}
      >
        <PageCover
          title="Flight Status"
          subtitle="Welcome to Our World, Where Innovation Meets Purpose, and Possibilities Unfold"
          image={flightStatus}
        />
      </motion.div>
      <Box as="section">
        <Box className="flightStatus">
          <Container>
            <motion.div
              initial={{ x: -120, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 1, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <Row>
                <Col lg={12}>
                  <Box className="tabs cstTabs">
                    <Tabs
                      value={value}
                      onChange={tabChange}
                      aria-label="Flight Status Tabs"
                    >
                      <Tab className="tabBtn D-font" label="Flight Number" />
                      <Tab className="tabBtn D-font" label="PNR" />
                    </Tabs>
                    <Box
                      role="tabpanel"
                      className="tabBox"
                      hidden={value !== 0}
                    >
                      <Row>
                        <Col lg={4} md={6} sm={12} className="mb-3">
                          <TextField
                            id="outlined-basic"
                            fullWidth
                            className="bookTextfield"
                            label="Flight Number "
                            variant="outlined"
                            value={flightNumber}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col lg={4} md={6} sm={12} className="mb-3">
                          <FormControl fullWidth className="bookTextfield">
                            <InputLabel id="demo-simple-select-label">
                              Select Date
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={flightDate}
                              label="Select Date"
                              onChange={changeDropdown}
                            >
                              <MenuItem value={10}>12 May 2025</MenuItem>
                              <MenuItem value={20}>13 May 2025</MenuItem>
                              <MenuItem value={30}>14 May 2025</MenuItem>
                            </Select>
                          </FormControl>
                        </Col>
                        <Col lg={2} className="btnWrapper">
                          <Button
                            onClick={checkFlightStatus}
                            style={{ fontSize: "16px" }}
                            variant="link"
                            className="coverBtn bg-orange btnIcon D-font"
                          >
                            Check Status
                          </Button>
                        </Col>
                        <Col lg={12}>
                          {status && (
                            <p>
                                {status}
                            </p>
                          )}
                        </Col>
                      </Row>
                    </Box>
                    <Box
                      role="tabpanel"
                      className="tabBox"
                      hidden={value !== 1}
                    >
                      <Row>
                        <Col lg={4} md={6} sm={12} className="mb-3">
                          <TextField
                            id="outlined-basic"
                            fullWidth
                            className="bookTextfield"
                            label="PNR Number "
                            variant="outlined"
                          />
                        </Col>
                        <Col lg={4} md={6} sm={12} className="mb-3">
                          <TextField
                            id="outlined-basic"
                            fullWidth
                            className="bookTextfield"
                            label="Name"
                            variant="outlined"
                          />
                        </Col>
                        <Col lg={2} className="btnWrapper">
                          <Button
                            style={{ fontSize: "16px" }}
                            variant="link"
                            className="coverBtn bg-orange btnIcon D-font"
                          >
                            Check Status
                          </Button>
                        </Col>
                      </Row>
                    </Box>
                  </Box>
                </Col>
              </Row>
            </motion.div>
          </Container>
        </Box>
        <Box className="flightStatusContent" style={{ padding: "40px 0", backgroundColor: "#f7fbff" }}>
          <Container>
            <Row>
              <Col lg={12}>
                <Box>
                  <Typography component="p" className="justify mb-5 ">
                    Flight status is a service that provides real-time
                    information about the status of flights, including departure
                    and arrival times, delays, cancellations, and gate
                    information. This service is essential for travelers,
                    airlines, and airport personnel to stay informed about
                    flight operations. Flight status can be accessed through
                    various channels, including airline websites, mobile apps,
                    and airport displays. It helps passengers plan their travel
                    accordingly and ensures a smooth travel experience.
                  </Typography>
                  <Typography component="p" className="justify mb-5 ">
                    Once you book your flight tickets with Shankh Air, you can check
                    the flight status on the go from anywhere and at any time.
                    Shankh Air intuitive and user-friendly mobile app, as well
                    as the website, lets you enjoy the convenience of checking
                    your flight pnr status in a few simple steps which include
                    entering your PNR number and other details related to your
                    booking. When there is so much to offer, it's hard to
                    imagine a better way to book your flights than with Shankh Air,
                    which meets all your travel needs in one place!
                  </Typography>
                  <Typography variant="h2" className="mb-4" style={{fontSize:'45ox', fontWeight: '500'}}>How to track Flight status?</Typography>
                    <Typography component="ol" className="mb-5 statusinstruct">
                      <li>Enter your <strong>Flight Number</strong> in the provided text field.</li>
                      <li>Select the <strong>Date</strong> of your flight from the dropdown menu.</li>
                      <li>Click on the <strong>Check Status</strong> button to retrieve the flight status.</li>
                      <li>If you prefer to use your PNR, switch to the <strong>PNR</strong> tab.</li>
                      <li>Enter your <strong>PNR Number</strong> and <strong>Name</strong> in the respective fields.</li>
                      <li>Click on the <strong>Check Status</strong> button to view the flight details.</li>
                    </Typography>
                </Box>
              </Col>
            </Row>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default FlightStatus;
